import type { CodeReviewPrReviewsResponse } from "@yagni/shared";

/** What a stopped review says, keyed by the report's public failure code. */
const REVIEW_FAILURE_SENTENCES: Record<string, string> = {
  review_generate_failed: "Proctor could not finish writing this review.",
  review_prepare_failed: "Proctor could not check out this pull request.",
  review_post_failed: "Proctor wrote the review but could not post it to GitHub.",
  review_deadline_exceeded: "The review ran out of time.",
  premise_stale:
    "The pull request changed during the review, so this review was dropped. Proctor reviews the new head.",
  premise_unverifiable:
    "Proctor could not confirm the pull request's head during the review, so this review was dropped.",
};

export const REVIEW_FAILURE_FALLBACK = "This review stopped before it finished.";

export function reviewFailureSentence(reason: string): string {
  return Object.hasOwn(REVIEW_FAILURE_SENTENCES, reason)
    ? REVIEW_FAILURE_SENTENCES[reason]
    : REVIEW_FAILURE_FALLBACK;
}

/** Whether Proctor tries again by itself; null prints nothing. */
export function reviewRetryLine(retry: CodeReviewPrReviewsResponse["retry"]): string | null {
  if (retry === "automatic") return "Proctor tries again on its own.";
  if (retry === "parked") return "Proctor stopped trying on this head. Push again to retry.";
  return null;
}
